export const inverseValue = (
  x: number,
  xMin = 1,
  xMax = Number.MAX_SAFE_INTEGER,
  yMin = 1,
  yMax = 10000,
) => {
  // Clamp the input value to the valid input range
  x = Math.min(Math.max(x, xMin), xMax)

  // Normalize x to a value between 0 and 1, but inverted
  const t = (xMax - x) / (xMax - xMin)

  // Scale to the target output range
  const y = yMin + t * (yMax - yMin)

  return Math.round(y)
}
